export default __webpack_public_path__ + "b0c117571a0f7c8700f0ba482dce9769.svg";